import { usersService } from '../../helpers/services/users.service'
import i18n from '@/i18n'
import { sharedHelper, filtersHelper } from '@/utils'

export const state = {
  list: {
    data: [],
    pagination: { pageNumber: 0, pageSize: 0, lastPage: 0, tableRowsCount: 0 },
  },
  details: {},
  status: { list: true, detail: true, save: true },
}

export const USERS_MODULE = 'users'

// ACTIONS
export const GET_ALL_USER = 'getAllUser'
export const GET_USERS = 'getUsers'
export const CREATE_USERS = 'createUsers'
export const UPDATE_USERS = 'updateUsers'
export const UPDATE_USERS_STATUS = 'updateUsersStatus'
export const UPDATE_USERS_LOGIN_ACCESS = 'updateUsersLoginAccess'
export const UNLOCK_USERS = 'unlockUsers'

// MUTATIONS
const REQUESTING = 'requesting'
const ALL_USERS_SUCCESS = 'allUsersSuccess'
const SUCCESS = 'commonSuccess'
const FAILURE = 'commonFailure'
const GET_USERS_SUCCESS = 'getUsersSuccess'

function mapUserRow(item) {
  return {
    id: item.uuid,
    name: item.name,
    email: item.email,
    agentCode: item.agent_code,
    locationCode: item.location_code,
    isVerified: item.is_verified,
    isLocked: item.is_locked,
    isActive: item.is_active,
    isAllowLogin: item.is_allow_login,
    roles: (item.roles || []).map((r) => ({ id: r.uuid, name: r.name })),
    createdAt: filtersHelper.getDateFormat(item.created_at),
    updatedAt: filtersHelper.getDateFormat(item.updated_at),
  }
}

export const actions = {
  [GET_ALL_USER]({ commit }, { filter }) {
    commit(REQUESTING, 'list')
    usersService
      .getAllUsers(filter)
      .then((result) => {
        commit(ALL_USERS_SUCCESS, { data: result })
        commit(SUCCESS)
      })
      .catch((error) => {
        sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code)
        commit(FAILURE)
      })
  },
  [GET_USERS]({ commit }, { id }) {
    commit(REQUESTING, 'detail')
    return usersService
      .getUser(id)
      .then((result) => {
        commit(GET_USERS_SUCCESS, result)
        commit(SUCCESS)
        return result
      })
      .catch((error) => {
        sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code)
        commit(FAILURE)
      })
  },
  [CREATE_USERS]({ commit, dispatch }, { data, filter }) {
    commit(REQUESTING, 'save')
    return usersService
      .createUser(data)
      .then((result) => {
        sharedHelper.alertSuccessMessage(i18n.t('label.createX', [i18n.t('module.user')]))
        commit(SUCCESS)
        dispatch(GET_ALL_USER, { filter })
        return result
      })
      .catch((error) => {
        sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code)
        commit(FAILURE)
      })
  },
  [UPDATE_USERS]({ commit, dispatch }, { id, data, filter }) {
    commit(REQUESTING, 'save')
    return usersService
      .updateUser(id, data)
      .then((result) => {
        sharedHelper.alertSuccessMessage(i18n.t('label.updateX', [i18n.t('module.user')]))
        commit(SUCCESS)
        dispatch(GET_ALL_USER, { filter })
        return result
      })
      .catch((error) => {
        sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code)
        commit(FAILURE)
      })
  },
  [UPDATE_USERS_STATUS]({ commit, dispatch }, { id, isActive, filter }) {
    commit(REQUESTING, 'save')
    return usersService
      .updateUserStatus(id, isActive)
      .then((result) => {
        sharedHelper.alertSuccessMessage(i18n.t('label.updateX', [i18n.t('label.status')]))
        commit(SUCCESS)
        dispatch(GET_ALL_USER, { filter })
        return result
      })
      .catch((error) => {
        sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code)
        commit(FAILURE)
      })
  },
  [UPDATE_USERS_LOGIN_ACCESS]({ commit, dispatch }, { id, isAllowLogin, filter }) {
    commit(REQUESTING, 'save')
    return usersService
      .updateUserLoginAccess(id, isAllowLogin)
      .then((result) => {
        sharedHelper.alertSuccessMessage(i18n.t('label.updateX', [i18n.t('user.allowLogin')]))
        commit(SUCCESS)
        dispatch(GET_ALL_USER, { filter })
        return result
      })
      .catch((error) => {
        sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code)
        commit(FAILURE)
      })
  },
  [UNLOCK_USERS]({ commit, dispatch }, { id, filter }) {
    commit(REQUESTING, 'save')
    return usersService
      .unlockUser(id)
      .then((result) => {
        sharedHelper.alertSuccessMessage(i18n.t('label.unlockAccount'))
        commit(SUCCESS)
        dispatch(GET_ALL_USER, { filter })
        return result
      })
      .catch((error) => {
        sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code)
        commit(FAILURE)
      })
  },
}

export const mutations = {
  [ALL_USERS_SUCCESS](state, { data }) {
    const users = data.data || []
    state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)
    state.list.data = data.success ? users.map(mapUserRow) : users
  },
  [GET_USERS_SUCCESS](state, data) {
    state.details = mapUserRow(data.data || {})
  },
  [FAILURE](state) {
    state.status = { list: true, detail: true, save: true }
  },
  [REQUESTING](state, type) {
    state.status[type] = false
  },
  [SUCCESS](state) {
    state.status = { list: true, detail: true, save: true }
  },
}
